import * as oAuthApps from '@wix/auto_sdk_auth-management_o-auth-apps';

export { oAuthApps };
